import { Component, type ReactNode } from 'react';
import Error500Page from '@pages/error/500';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

export class LazyRouteErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.error('Lazy route loading error:', error, errorInfo);
    }

    render(): ReactNode {
        if (this.state.hasError) {
            return <Error500Page />;
        }

        return this.props.children;
    }
}
